import { ref, type Ref } from 'vue';

export type ViewType = 'list' | 'grid';

export interface GridList {
  viewType: Ref<ViewType>;
  switchViewType(t: ViewType): void;
}

export function useGridList(): GridList {
  const viewType = ref<ViewType>('list');
  return {
    viewType,
    switchViewType(t) {
      viewType.value = t;
    },
  };
}
